export const API_URL = "https://verify.ishcallsign.com/";
export const IDP_API_URL = "https://idp.ishcallsign.com/api/";
export const CMS_API_URL = "https://admin.ishcallsign.com/api/";